import Api from './Api';
import Configuracao from '../util/Configuracao';

class CalculoAtuarialApi extends Api {
  async consultarProcedimentosTitulares (filter) {
    try {
      const urlConsultarProcedimentosTitulares = Configuracao.getConfiguracao().urlConsultarProcedimentosTitulares  +
      filter.codTipoData + '/' +
      filter.dataInicial + '/' +
      filter.dataFinal;
      const response = await this.fetch(urlConsultarProcedimentosTitulares);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarProcedimentosDependentes (filter) {
    try {
      const urlConsultarProcedimentosDependentes = Configuracao.getConfiguracao().urlConsultarProcedimentosDependentes  +
      filter.codTipoData + '/' +
      filter.dataInicial + '/' +
      filter.dataFinal;
      const response = await this.fetch(urlConsultarProcedimentosDependentes);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarOpmesTitulares (filter) {
    try {
      const urlConsultarOpmesTitulares = Configuracao.getConfiguracao().urlConsultarOpmesTitulares  +
      filter.codTipoData + '/' +
      filter.dataInicial + '/' +
      filter.dataFinal;
      const response = await this.fetch(urlConsultarOpmesTitulares);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarOpmesDependentes (filter) {
    try {
      const urlConsultarOpmesDependentes = Configuracao.getConfiguracao().urlConsultarOpmesDependentes  +
      filter.codTipoData + '/' +
      filter.dataInicial + '/' +
      filter.dataFinal;
      const response = await this.fetch(urlConsultarOpmesDependentes);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDespesasTitulares (filter) {
    try {
      const urlConsultarDespesasTitulares = Configuracao.getConfiguracao().urlConsultarDespesasTitulares  +
      filter.codTipoData + '/' +
      filter.dataInicial + '/' +
      filter.dataFinal;
      const response = await this.fetch(urlConsultarDespesasTitulares);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDespesasDependentes (filter) {
    try {
      const urlConsultarDespesasDependentes = Configuracao.getConfiguracao().urlConsultarDespesasDependentes  +
      filter.codTipoData + '/' +
      filter.dataInicial + '/' +
      filter.dataFinal;
      const response = await this.fetch(urlConsultarDespesasDependentes);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarCalculoPrestadores (filter) {
    try {
      const urlConsultarCalculoPrestadores = Configuracao.getConfiguracao().urlConsultarCalculoPrestadores  +
      filter.codTipoData + '/' +
      filter.dataInicial + '/' +
      filter.dataFinal;
      const response = await this.fetch(urlConsultarCalculoPrestadores);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarCalculoUsuarios (filter) {
    try {
      const urlConsultarCalculoUsuarios = Configuracao.getConfiguracao().urlConsultarCalculoUsuarios  +
      filter.codTipoData + '/' +
      filter.dataInicial + '/' +
      filter.dataFinal;
      const response = await this.fetch(urlConsultarCalculoUsuarios);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarCalculoReceitas (filter) {
    try {
      const urlConsultarCalculoReceitas = Configuracao.getConfiguracao().urlConsultarCalculoReceitas  +
      filter.codTipoData + '/' +
      filter.dataInicial + '/' +
      filter.dataFinal;
      const response = await this.fetch(urlConsultarCalculoReceitas);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarCalculoReembolsos (filter) {
    try {
      const urlConsultarCalculoReembolsos = Configuracao.getConfiguracao().urlConsultarCalculoReembolsos  +
      filter.codTipoData + '/' +
      filter.dataInicial + '/' +
      filter.dataFinal;
      const response = await this.fetch(urlConsultarCalculoReembolsos);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarCovidAutorizacao (filter) {
    try {
      const urlConsultarCovidAutorizacao = Configuracao.getConfiguracao().urlConsultarCovidAutorizacao  +
      filter.codTipoData + '/' +
      filter.dataInicial + '/' +
      filter.dataFinal;
      const response = await this.fetch(urlConsultarCovidAutorizacao);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarCovidFaturamento (filter) {
    try {
      const urlConsultarCovidFaturamento = Configuracao.getConfiguracao().urlConsultarCovidFaturamento  +
      filter.codTipoData + '/' +
      filter.dataInicial + '/' +
      filter.dataFinal;
      const response = await this.fetch(urlConsultarCovidFaturamento);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default CalculoAtuarialApi;
